module.exports = new __parcel__URL__("insight-object-view-skeleton.tpl.6c773a02.svg").toString();